<mat-form-field *transloco="let t" appearance="standard" class="w-100">
    <mat-label>{{ t('fields.json-value') }}</mat-label>
    <input matInput [formControl]="innerControl" type="text" [placeholder]="t('general.enter-value')" />
    <mat-error>
        <td-validation-messages [control]="innerControl" [context]="{ name: key }"></td-validation-messages>
    </mat-error>
</mat-form-field>
